function openVideoPopup(thumbnail) {
    var videoUrl = $(thumbnail)
    .closest(".customer-journey-img")
    .data("video-url");
    $("#popup1 video source").attr("src", videoUrl);
    $("#popup1 video")[0].load();
    $("#popup1 video")[0].play();
    $("#popup1").show();
}

function closeVideoPopup(popupNumber) {
  var videoElement = $("#popup" + popupNumber + " video")[0];

  // Pause the video
  videoElement.pause();

  // Reset the video to the beginning
  videoElement.currentTime = 0;

  // Hide the popup
  $("#popup" + popupNumber).hide();
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    if (targetId === '') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const yOffset = -120;
      const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  });
});

if (screen.width <= 767) {
   $(document).ready(function () {
      $(".footer-block__heading").append("<i class='fa-solid fa-plus' aria-hidden='true'></i>");
      $(".footer-block__heading").click(function () {
         if ($(this).children().hasClass('fa-plus')) {
            $(this).find(".fa-solid").removeClass("fa-plus").addClass("fa-minus");
         }
         else {
            $(this).find(".fa-solid").removeClass("fa-minus").addClass("fa-plus");
         }
         $(this).next('.footer-block__details-content').slideToggle();
      });
   });
}

if (screen.width <= 767) {
 $(document).ready(function () {
    $(".menu-item-with-submenu .submenu-item-link-wrapper").append("<i class='fa fa-angle-down' aria-hidden='true'></i>");
    $(".menu-item-with-submenu .submenu-item-link-wrapper").click(function () {
       if ($(this).children().hasClass('fa-angle-down')) {
          $(this).find(".fa-angle-down").removeClass("fa-angle-down").addClass("fa-angle-up");
       }
       else {
          $(this).find(".fa-angle-up").removeClass("fa-angle-up").addClass("fa-angle-down");
       }
       $(this).next('.menu-item-with-submenu .submenu').slideToggle();
    });
 });
}

if (screen.width <= 767) {
    $(document).ready(function(){
        $(".accordion-tab-head, .table-of-contents h2").append("<i class='fa fa-angle-down' aria-hidden='true'></i>");
      $(".accordion-tab-head, .table-of-contents h2").click(function(){

        if($(this).children().hasClass('fa-angle-down')){
            $(this).find(".fa-angle-down").removeClass("fa-angle-down").addClass("fa-angle-up");
        }
        else {
            $(this).find(".fa-angle-up").removeClass("fa-angle-up").addClass("fa-angle-down");
        }

        $(this).next('.accordion-tab .accordion-tab-content, .table-of-contents ul').slideToggle();
      });
    });
}

var swiper = new Swiper(".day-night-swiper", {
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
   navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
     hide: false,
  },
  breakpoints: {
    100: {
      slidesPerView: 1.1,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    1024: {
      slidesPerView: 3,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: 
        {
          hide:false,
        }
    },
  },
});

var swiper = new Swiper(".not-found-page-swiper", {
  slidesPerView: 4,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
   navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
     hide: false,
  },
  breakpoints: {
    100: {
      slidesPerView: 1.1,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    1024: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: 
        {
          hide:false,
        }
    },
  },
});

var swiper = new Swiper(".grid-swiper-carousel", {
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
   navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
     hide: false,
  },
  breakpoints: {
    100: {
      slidesPerView: 1.2,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
         hide: false,
      },
    },
    768: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
         hide: true,
      },
    },
    1024: {
      slidesPerView: 3,
      pagination: {
        hide:false,
      },
      navigation: 
        {
          hide:false,
        }
    },
  },
});

$(document).ready(function(){
  $(".day-night-owl-swiper").owlCarousel({
    items: 3,                      
    margin: 20,                 
    loop: true,                    
    center: true,                  
    nav: true,                 
    navText: ["<", ">"],         
    responsive: {
      0: {
        items: 1,                  
      },
      768: {
        items: 3,                  
      },
      1024: {
        items: 3,                 
      }
    }
  });
});


$(document).ready(function(){
  $(".night-owl-swiper").owlCarousel({
    items: 3,                      
    margin: 20,                 
    loop: true,                    
    center: true,                  
    nav: true,                 
    navText: ["<", ">"],         
    responsive: {
      0: {
        items: 1,                  
      },
      768: {
        items: 3,                  
      },
      1024: {
        items: 3,                 
      }
    }
  });
});

var swiper = new Swiper(".night-swiper", {
  slidesPerView: 1.6,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    100: {
      slidesPerView: 1.1,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 1.2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    1024: {
      slidesPerView: 1.6,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

$(document).ready(function() {
  var $resultsSwiper = $(".results-swiper");
  var $bottomSlide = null;
  var $bottomSlideContent = null; 
  var swiperCentred = new Swiper(".results-swiper", {
    spaceBetween: 0,
    slidesPerView: 3,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
        el: ".swiper-pagination",
    },
    loopAdditionalSlides: 1, 

    breakpoints: {
      320: { 
        slidesPerView: 1.2,
        centeredSlides: true,
        loop: true,
        spaceBetween: 0,
      },
      640: { 
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
      }
    }
  });
});



var swiper = new Swiper(".product-results-swiper", {
  slidesPerView: 4,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    100: {
      slidesPerView: 1.2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 1.2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    1024: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});



$(document).ready(function () {
  var swiper = new Swiper(".night-center-swiper", {
    spaceBetween: 30,
    slidesPerView: 3,
    centeredSlides: true,
    loop: true,
    loopFillGroupWithBlank: true,
    loopedSlides: 3,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
});


$('.slick-slide').css({
  margin: '0 15px',
});

var swiper = new Swiper(".aligerco-family-swiper-wrapper", {
  slidesPerView: 4,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    100: {
      slidesPerView: 2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    1024: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

$(function () {
  var result_owl = $(".bridal-before-after");
  result_owl.owlCarousel({
    items: 3,
    margin: 30,
    speed: 1000,
    loop: false,
    nav: false,
    dots: false,
    autoplay: false,
    responsive: {
      0: {
        items: 1.3,
        dots: true,
        autoplay: false,
        loop: true,
      },
      600: {
        items: 3,
      },
      992: {
        items: 3,
      },
    },
  });

  result_owl.on("click", ".owl-item", function (e) {
    var carousel = $(".bridal-before-after").data("owl.carousel");
    e.preventDefault();
    carousel.to(carousel.relative($(this).index()));
  });
});



$(document).ready(function () {
      $.ajax({
          url: 'https://assessment.alignerco.com/trustpilot-reviews-slider/fetch_reviews.php?shop=alignerco-usa.myshopify.com',
          method: 'GET',
          success: function (data) {
              const reviews = JSON.parse(data);

              if (reviews.length === 0) {
                  $('.trustpilot-reviews-slider').html('<p>No reviews available.</p>');
              } else {
                  reviews.forEach(function (review) {
                      let reviewText = review.review_text.split(' ').slice(0, 10).join(' ') + '...';

                      const reviewHtml = `
                          <div class="item">
                              <div class="review-card">
                                  <a href="https://www.trustpilot.com/review/alignerco.com?utm_medium=trustbox&utm_source=Mini" target="_blank">
                                      <img src="${review.rating_image}" alt="Rating Image" width="798" height="148" loading="lazy" />
                                  </a>
                                  <div class="trustpilot-content-wrapper">
                                  <h4>
                                      <a href="https://www.trustpilot.com/review/alignerco.com?utm_medium=trustbox&utm_source=Mini" target="_blank">
                                          ${review.reviewer_title}
                                      </a>
                                  </h4>
                                  
                                  <p>${reviewText}</p>
                                  </div>
                                  <h3>${review.reviewer_name}</h3>
                              </div>
                          </div>
                      `;
                      $('.trustpilot-reviews-slider').append(reviewHtml);
                  });

                  var trustpilotReviews = $(".trustpilot-reviews-slider");
                  trustpilotReviews.owlCarousel({
                      items: 4.5,
                      margin: 20,
                      speed: 1000,
                      loop: true,
                      nav: true,
                      center: true,
                      navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right'></i>"],
                      dots: true,
                      autoplay: false,
                      responsive: {
                          0: {
                              items: 1.3,
                              loop: true,
                              nav: true,
                          },
                          600: {
                              items: 3,
                              nav: true,
                          },
                          992: {
                              items: 4.5,
                              nav: true,
                          }
                      }
                  });
              }
          },
          error: function (err) {
              console.error("Error fetching reviews:", err);
              $('.trustpilot-reviews-slider').html('<p>Error loading reviews.</p>');
          }
      });
  });

jQuery(document).ready(function () {
  jQuery(".accordion .accordion-title").append(
    "<i class='fa fa-plus' aria-hidden='true'></i>"
  );
  jQuery(".accordion .accordion-title").click(function () {
    if (jQuery(this).children().hasClass("fa-plus")) {
      jQuery(this).find(".fa-plus").removeClass("fa-plus").addClass("fa-minus");
    } else {
      jQuery(this)
        .find(".fa-minus")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    }
    jQuery(this).next(".accordion .accordion-content").slideToggle();
  });
});

$(document).ready(function() {
  $('ul.products-tabs-new-layout').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
});

jQuery(document).ready(function($) {
function updatePuttyPrice() {
    let selectedPuttyOption = $('#putty-dropdown option:selected');
    let puttyOriginalPrice = selectedPuttyOption.data('original-price');
    let puttyCurrentPrice = selectedPuttyOption.data('price');
    $('#putty-original-price').text(puttyOriginalPrice);
    $('#putty-current-price').text(puttyCurrentPrice);
}

function updateRetainerPrice() {
    let selectedRetainerOption = $('#retainer-dropdown option:selected');
    let retainerOriginalPrice = selectedRetainerOption.data('original-price');
    let retainerCurrentPrice = selectedRetainerOption.data('price');
    $('#retainer-original-price').text(retainerOriginalPrice);
    $('#retainer-current-price').text(retainerCurrentPrice);
}
  
function updateDentalPrice() {
    let selectedDentalOption = $('#dental-impression-dropdown option:selected');
    let dentalOriginalPrice = selectedDentalOption.data('original-price');
    let dentalCurrentPrice = selectedDentalOption.data('price');
    $('#dental-impression-original-price').text(dentalOriginalPrice);
    $('#dental-impression-current-price').text(dentalCurrentPrice);
}

function updateCarePrice() {
    let selectedCareOption = $('#care-kit-dropdown option:selected');
    let careOriginalPrice = selectedCareOption.data('original-price');
    let careCurrentPrice = selectedCareOption.data('price');
    $('#care-kit-original-price').text(careOriginalPrice);
    $('#care-kit-current-price').text(careCurrentPrice);
}

function updateUVSonicPrice() {
    let selectedUvSonicOption = $('#uv-ultrasonic-cleaner-dropdown option:selected');
    let uvSonicOriginalPrice = selectedUvSonicOption.data('original-price');
    let uvSonicCurrentPrice = selectedUvSonicOption.data('price');
    $('#uv-ultrasonic-cleaner-original-price').text(uvSonicOriginalPrice);
    $('#uv-ultrasonic-cleaner-current-price').text(uvSonicCurrentPrice);
}

function updateCleansingTabletsPrice() {
    let selectedCleansingTabletsOption = $('#cleansing-tablets-dropdown option:selected');
    let cleansingTabletsOriginalPrice = selectedCleansingTabletsOption.data('original-price');
    let cleansingTabletsCurrentPrice = selectedCleansingTabletsOption.data('price');
    $('#cleansing-tablets-original-price').text(cleansingTabletsOriginalPrice);
    $('#cleansing-tablets-current-price').text(cleansingTabletsCurrentPrice);
}

  
$('#putty-dropdown').change(updatePuttyPrice);
$('#retainer-dropdown').change(updateRetainerPrice);
$('#dental-impression-dropdown').change(updateDentalPrice);
$('#care-kit-dropdown').change(updateCarePrice);
$('#uv-ultrasonic-cleaner-kit-dropdown').change(updateUVSonicPrice);
$('#cleansing-tablets-dropdown').change(updateCleansingTabletsPrice);
  
updatePuttyPrice();
updateRetainerPrice();
updateDentalPrice();
updateCarePrice();
updateUVSonicPrice();
updateCleansingTabletsPrice();
  
$('input[name="product_radio"]').not('#no-thanks').change(function() {
    if ($('input[name="product_radio"]:checked').not('#no-thanks').length > 0) {
        $('#no-thanks').prop('disabled', true).prop('checked', false);
    } else {
        $('#no-thanks').prop('disabled', false);
    }
});

$('#no-thanks').change(function() {
    if ($(this).is(':checked')) {
        $('input[name="product_radio"]').not('#no-thanks').prop('checked', false);
    }
});

$(".btnCheckout").click(function () {
    let searchParams = new URLSearchParams(window.location.search);
    let product_id = searchParams.get('id');
    let quantity = searchParams.get('qty') || 1;

    if (!product_id) {
        return;
    }

    let url = 'https://alignerco-usa.myshopify.com/cart/' + product_id + ":" + quantity;

    if ($('#radio-putty').is(':checked')) {
        let puttyDropdown = $('#putty-dropdown').val();
        if (puttyDropdown) {
            url += "," + puttyDropdown + ':1';
        }
    }

    if ($('#radio-retainer').is(':checked')) {
        let retainerDropdown = $('#retainer-dropdown').val();
        if (retainerDropdown) {
            url += "," + retainerDropdown + ':1';
        }
    }

    if ($('#radio-dental-impression').is(':checked')) {
        let dentalDropdown = $('#dental-impression-dropdown').val();
        if (dentalDropdown) {
            url += "," + dentalDropdown + ':1';
        }
    }

    if ($('#radio-care-kit').is(':checked')) {
        let careDropdown = $('#care-kit-dropdown').val();
        if (careDropdown) {
            url += "," + careDropdown + ':1';
        }
    }

    if ($('#radio-uv-ultrasonic-cleaner').is(':checked')) {
        let uvSonicDropdown = $('#uv-ultrasonic-cleaner-dropdown').val();
        if (uvSonicDropdown) {
            url += "," + uvSonicDropdown + ':1';
        }
    }

    if ($('#radio-cleansing-tablets').is(':checked')) {
        let cleansingDropdown = $('#cleansing-tablets-dropdown').val();
        if (cleansingDropdown) {
            url += "," + cleansingDropdown + ':1';
        }
    }

    // if ($('#radio-travel-kit').is(':checked')) {
    //     let travelDropdown = $('#travel-kit-dropdown').val();
    //     if (travelDropdown) {
    //         url += "," + travelDropdown + ':1';
    //     }
    // }

    window.location = url;
});
});

function openImpressionPopup(videoUrl) {
    const popup = document.getElementById('impressionPopup');
    const videoFrame = document.getElementById('impressionVideoFrame');
    videoFrame.src = videoUrl; 
    popup.style.display = 'block';
}

function closeImpressionPopup(event) {
    const popup = document.getElementById('impressionPopup');
    const videoFrame = document.getElementById('impressionVideoFrame');
    
    if (!event || event.target === popup) {
        popup.style.display = 'none';
        videoFrame.src = '';
    }
}


$(function () {
  var beforeowl = $(".testimonials-owl");
  beforeowl.owlCarousel({
    items: 1,
    margin: 20,
    speed: 1000,
    loop: true,
    nav: true,
    dots: false,
    autoHeight: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      992: {
        items: 1
      }
    }
  });
});


jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form/index.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-form-new").attr("src", formUrl);
});


jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form_spanish/index.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-form-new-es").attr("src", formUrl);
});

jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form/prom-form.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-prom-form").attr("src", formUrl);
});

jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form/bridal-form.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-bridal-form").attr("src", formUrl);
});

jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form/lp-assessment.php?website=lp" +
    "&page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-form-new-lp").attr("src", formUrl);
});


jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form/braces-teen.php?website=lp" +
    "&page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#teen-assessment").attr("src", formUrl);
});

jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_es.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-form-es").attr("src", formUrl);
});

jQuery(document).ready(function () {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var utmSource = getParameterByName("utm_source");
  var utmMedium = getParameterByName("utm_medium");
  var utmCampaign = getParameterByName("utm_campaign");
  var utmGclid = getParameterByName("utm_gclid");
  var pageSource = window.location.href;
  var formUrl =
    "https://assessment.alignerco.com/assessment_form_spanish/index.php?" +
    "page_source=" +
    encodeURIComponent(pageSource) +
    "&utm_source=" +
    utmSource +
    "&utm_medium=" +
    utmMedium +
    "&utm_campaign=" +
    utmCampaign +
    "&utm_gclid=" +
    utmGclid;
  jQuery("#assessment-form-new-es").attr("src", formUrl);
});

function opencountryPopup(popupId) {
    document.getElementById(popupId).style.display = 'flex';
}
function closecountryPopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
}

function openPromPopup(popupId) {
    document.getElementById(popupId).style.display = 'flex';
}
function closePromPopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
}

function openBridalPopup(popupId) {
    document.getElementById(popupId).style.display = 'flex';
}

function closeBridalPopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
}

function openPopup(popupId) {
    document.getElementById(popupId).style.display = 'flex';
}
function closePopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
}

function openSwitchPopup(popupId) {
    document.getElementById(popupId).style.display = 'flex';
}
function closeSwitchPopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
}

document.addEventListener("DOMContentLoaded", function () {
  const contentSections = document.querySelectorAll(".content");
  const readMoreButtons = document.querySelectorAll(".read-more-button");
  readMoreButtons.forEach((button, index) => {
    let isExpanded = false;

    button.addEventListener("click", function () {
      if (!isExpanded) {
        contentSections[index].style.maxHeight = "none";
        button.textContent = "Read Less";
      } else {
        contentSections[index].style.maxHeight = "100px";
        button.textContent = "Read More";
      }
      isExpanded = !isExpanded;
    });
  });
});

$(document).ready(function () {
   if (screen.width <= 767) {
     $('.fixed-cta').hide();
     $(window).scroll(function () {
       if ($(this).scrollTop() > 600) {
         $('.fixed-cta').show();
       } else {
         $('.fixed-cta').hide();
       }
     });
   }
 });

function openPopup(author_popup) {
    document.getElementById(author_popup).style.display = 'flex';
}

function closePopup(author_popup) {
    document.getElementById(author_popup).style.display = 'none';
}

jQuery(document).ready(function () {
  jQuery(".footer-copyright-grid-row .read-more-text").each(function () {
    if (!jQuery(this).find("i").length) {
      jQuery(this).append(" <i class='fa fa-angle-down' aria-hidden='true'></i>");
    }
  });

  jQuery(".footer-copyright-grid-row .braces-cost-cities-wrapper .read-more-text").click(function () {
    var icon = jQuery(this).find("i");
    jQuery(".teeth-straightening-cities-content").slideUp(300);
    jQuery(".teeth-straightening-cities-wrapper .read-more-text i").removeClass("fa-angle-up").addClass("fa-angle-down");
    jQuery(".braces-cost-cities-content").stop(true, true).slideToggle(300);
    icon.toggleClass("fa-angle-down fa-angle-up");
  });

  jQuery(".footer-copyright-grid-row .teeth-straightening-cities-wrapper .read-more-text").click(function () {
    var icon = jQuery(this).find("i");
    jQuery(".braces-cost-cities-content").slideUp(300);
    jQuery(".braces-cost-cities-wrapper .read-more-text i").removeClass("fa-angle-up").addClass("fa-angle-down");

    jQuery(".teeth-straightening-cities-content").stop(true, true).slideToggle(300);
    icon.toggleClass("fa-angle-down fa-angle-up");
  });
});

$(document).ready(function(){
  $(".product-mouthguard-carousel").owlCarousel({
    items: 1,                      
    margin: 20,                 
    loop: false,                             
    nav: false,
    center: false,
    navText: ["<", ">"],         
    responsive: {
      0: {
        items: 3,
        loop: false,
        center: false,
      },
      768: {
        items: 3.2,                  
      },
      1024: {
        items: 4,                 
      }
    }
  });
});

$(document).ready(function(){
  $(".product-retainers-carousel").owlCarousel({
    items: 2,                      
    margin: 20,                 
    loop: false,                             
    nav: false,
    center: false,
    navText: ["<", ">"],         
    responsive: {
      0: {
        items: 3,
        loop: false,
      },
      768: {
        items: 3.2,                  
      },
      1024: {
        items: 2,                 
      }
    }
  });
});

$(document).ready(function () {
    const videoPopup = $('#videoPopup');
    const videoFrame = $('#videoFrame');
    const closeBtn = $('#closeBtn');
    $('.item img').on('click', function () {
        const videoSrc = $(this).closest('.video-wrapper').data('video');
        console.log('Video clicked, URL: ', videoSrc);
        videoFrame.attr('src', videoSrc);
        videoPopup.fadeIn();
    });
    closeBtn.on('click', function () {
        closeVideoPopup();
    });
    videoPopup.on('click', function (e) {
        if (!$(e.target).closest('.video-overlay-wrapper').length) {
            closeVideoPopup();
        }
    });
    function closeVideoPopup() {
        videoPopup.fadeOut();
        videoFrame.attr('src', '');
    }
});

jQuery(document).ready(function () {
     var searchParams = new URLSearchParams(window.location.search)
var emailID = searchParams.get('emailID');

jQuery(".sharesale").attr("src", "https://shareasale.com/sale.cfm?amount=0.00&tracking="+emailID+"&transtype=lead&merchantID=93437");
 });

document.addEventListener("DOMContentLoaded", function () {
  const cardItems = document.querySelectorAll(".card-item");
  let activeCard = null;
  let clickAllowed = true;

  cardItems.forEach((cardItem) => {
    cardItem.addEventListener("click", function () {
      // Check if click is allowed
      if (!clickAllowed) {
        return;
      }

      // Disable click for a short duration
      clickAllowed = false;
      setTimeout(() => {
        clickAllowed = true;
      }, 500);

      // If the clicked card is not the active card, set its width to 60%
      if (activeCard !== cardItem) {
        // Reset all card widths to 20%
        cardItems.forEach((item) => {
          item.style.width = "15%";
          // Show card-titel in each card-item on small devices
          if (screen.width <= 767) {
            const titleElement = item.querySelector(".card-titel");
            if (titleElement) {
              titleElement.style.display = "block";
            }
          }
        });
        cardItem.style.width = "70%";
        activeCard = cardItem;
      } else {
        // If the clicked card is already the active card, reset the activeCard
        activeCard = null;

        // Reset all card widths to initial value
        cardItems.forEach((item) => {
          item.style.width = "calc(33.33% - 20px)";
          // Show card-titel in each card-item on small devices
          if (screen.width <= 767) {
            const titleElement = item.querySelector(".card-titel");
            if (titleElement) {
              titleElement.style.display = "block";
            }
          }
        });
      }

      // Update the active card class
      cardItems.forEach((item) => {
        if (item === activeCard) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    });
  });
});

$(document).ready(function(){
  $(".blog-carousal").owlCarousel({
    items: 3,                      
    margin: 20,                 
    loop: true, 
    nav: false,  
    responsive: {
      0: {
        items: 1,  
      },
      768: {
        items: 3,                  
      },
      1024: {
        items: 3,  
         loop: false,
           mouseDrag: false
      }
    }
  });
});

$(document).ready(function(){
  var $carousel = $(".stories-carousel");

  $carousel.owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    nav: true,
    navText: ["<", ">"],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1024: {
        items: 1.5, // shows one full slide and half of the next
      }
    },
    onInitialized: function() {
      setTimeout(updateActiveSlide, 100); // Ensure active slide updates after init
    }
  });

  // Function to ensure only the fully visible slide remains 'active'
  function updateActiveSlide(){
      var $carouselContainer = $carousel;
      var containerLeft = $carouselContainer.offset().left;
      var $activeItems = $carouselContainer.find('.owl-item.active');
      var fullyVisibleItem;

      // Loop through active items to find the one that starts at or after the container’s left edge.
      $activeItems.each(function(){
         var $item = $(this);
         if($item.offset().left >= containerLeft){
            fullyVisibleItem = $item;
            return false; // break out of loop once found
         }
      });

      // Remove 'active' class from any active items that are not the fully visible one.
      $activeItems.not(fullyVisibleItem).removeClass('active');
  }

  // Run update on initialization and after each carousel translation.
  $carousel.on('initialized.owl.carousel translated.owl.carousel', function(){
      updateActiveSlide();
  });
});

function openPartnerPopup(partner_popup) {
    document.getElementById(partner_popup).style.display = 'flex';
}

function closePartnerPopup(partner_popup) {
    document.getElementById(partner_popup).style.display = 'none';
}

// Get all elements with the class 'video-section'
const videoSections = document.querySelectorAll('.video-wrapper');

// Loop through each video section to attach event listeners
videoSections.forEach(section => {
  const video = section.querySelector('.hover-gif'); // Get the video inside this section

    // Start video automatically on page load
  video.play();
  
   // Pause video on hover
  section.addEventListener('mouseenter', function() {
    video.pause();
  });

  // Pause and reset video on mouse leave
  section.addEventListener('mouseleave', function() {
    video.play();
  });
});


//inclusion popup
document.addEventListener('DOMContentLoaded', function() {
    const cards = document.querySelectorAll('.card');
    const popup = document.getElementById('descriptionPopup');
    const popupText = document.getElementById('popupText');
    const closeBtn = document.querySelector('.close-popup');

    // Add click event to each card
    cards.forEach(card => {
        card.addEventListener('click', function() {
            const description = this.getAttribute('data-description');
            popupText.textContent = description;
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        });
    });

    // Close popup when clicking close button
    closeBtn.addEventListener('click', function() {
        popup.style.display = 'none';
        document.body.style.overflow = 'auto';
    });

    // Close popup when clicking outside content
    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            popup.style.display = 'none';
            document.body.style.overflow = 'auto';
        }
    });

    // Close popup when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.style.display === 'flex') {
            popup.style.display = 'none';
            document.body.style.overflow = 'auto';
        }
    });
});









    (function () {
        const SWIPE_THRESHOLD = 10; // px

        function findCardHref(card) {
            if (!card) return null;

            let anchor = card.querySelector('a.primary-button[href]');
            if (anchor) return anchor.getAttribute('href');

            const primary = card.querySelector('.primary-button');
            if (primary) {
                const dh = primary.getAttribute('data-href') || primary.dataset?.href;
                if (dh) return dh;
                const maybeHref = primary.getAttribute && primary.getAttribute('href');
                if (maybeHref) return maybeHref;
            }

            const anyA = card.querySelector('a[href]');
            if (anyA) return anyA.getAttribute('href');

            const cardDh = card.getAttribute('data-href') || card.dataset?.href;
            if (cardDh) return cardDh;

            return null;
        }

        function toAbsolute(href) {
            try {
                return new URL(href, window.location.origin).href;
            } catch {
                return null;
            }
        }

        const touchStartX = new WeakMap();

        document.addEventListener('touchstart', e => {
            const card = e.target.closest('.product-item-wrapper');
            if (!card) return;
            touchStartX.set(card, e.touches[0].clientX);
        }, { passive: true });

        document.addEventListener('touchmove', e => {
            const card = e.target.closest('.product-item-wrapper');
            if (!card) return;
            const start = touchStartX.get(card) || 0;
            const diff = Math.abs((e.touches[0].clientX || 0) - start);
            if (diff > SWIPE_THRESHOLD) card._isSwipe = true;
        }, { passive: true });

        document.addEventListener('touchend', e => {
            const card = e.target.closest('.product-item-wrapper');
            if (!card) return;
            setTimeout(() => { card._isSwipe = false; }, 300);
        });

        document.addEventListener('click', e => {
            const card = e.target.closest('.product-item-wrapper');
            if (!card) return;

            const clickedAnchor = e.target.closest('a[href]');
            if (clickedAnchor) {
                if (clickedAnchor.classList.contains('primary-button')) return;
                return;
            }

            if (e.target.closest('.shopPayTooltipBtn') || e.target.closest('.tooltip-btn')) return;
            if (card._isSwipe) return;

            const href = findCardHref(card);
            if (!href) return;

            const absolute = toAbsolute(href);
            if (!absolute) return;

            e.preventDefault && e.preventDefault();
            e.stopPropagation && e.stopPropagation();

            window.location.href = absolute;
        }, false);

        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.product-item-wrapper').forEach(c => {
                c.style.cursor = 'pointer';
            });
        });
    })();
    
